export const PROPERTYGROUP_FETCH_IN_PROGRESS =
  "PROPERTYGROUP_FETCH_IN_PROGRESS";
export const PROPERTYGROUP_FETCH_SUCCESS = "PROPERTYGROUP_FETCH_SUCCESS";
export const PROPERTYGROUP_FETCH_ERROR = "PROPERTYGROUP_FETCH_ERROR";
export const SELECT_PROPERTY = "SELECT_PROPERTY";
export const SELECT_TRAP_ZONE = "SELECT_TRAP_ZONE";
export const SELECT_TRAP = "SELECT_TRAP";
